// Temp file that will be moved to ui-definitions in future
const ClientRoles = [
    {
        id: '1',
        displayName: 'View Only',
        label: 'View Only'
    },
    {
        id: '2',
        displayName: 'Maker',
        label: 'Maker'
    },
    {
        id: '3',
        displayName: 'Approver',
        label: 'Approver'
    },
    {
        id: '4',
        displayName: 'Full Access',
        label: 'Full Access'
    }
];

export const enum ClientRoleEnum {
    NOT_ASSIGNED = '0',
    VIEW_ONLY = '1',
    MAKER = '2',
    APPROVER = '3',
    FULL_ACCESS = '4'
}

export default ClientRoles;